<template>
  <div>
    <div id="bcid"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.startRecognize();
  },
  methods: {
    startRecognize() {
      console.log(1);
      //@ts-ignore
      if (!window.plus) return;
      //@ts-ignore
      console.log("window.plus", window.plus);
      //@ts-ignore
      let scan = new plus.barcode.Barcode("bcid");
      console.log("scan", scan);
      scan.onmarked = onmarked;
      function onmarked(type, result, file) {
        switch (type) {
          //@ts-ignore
          case plus.barcode.QR:
            type = "QR";
            break;
          //@ts-ignore
          case plus.barcode.EAN13:
            type = "EAN13";
            break;
          //@ts-ignore
          case plus.barcode.EAN8:
            type = "EAN8";
            break;
          default:
            type = "其它" + type;
            break;
        }
        // 获得code
        result = result.replace(/\n/g, "");
        console.log("result", result);
        alert(result)
      }
      scan.start();
    }
  }
};
</script>